Directives.SearchWorkspaceDirective =  function SearchWorkspaceDirective(){

    // @ngInject
    function SearchWorkspaceDirectiveControllerFunc($scope, $injector, AnalyticsService, $state, AppStates, UsersManager){

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SearchWorkspaceDirectiveController';
        this.membersExcludingMe = this.searchResult.members.filter(function (e) {
            return (e.email && (e.email !== UsersManager.getCurrUser().email));
        });

        this.goToWorkspace = function goToWorkspace (){

            $state.go(AppStates.root_core_navigation_event_workspace_feed, {workspace_id: this.searchResult.workspace_id, event_id: this.searchResult.event_id});

            AnalyticsService.track(this, AnalyticsService.analytics_events.search_result_item_clicked,
                {searched_id: this.workspaceId,
                 searched_type: 'Workspace'});

        };
    }

    var SearchWorkspaceDirectiveController = Class(Controllers.BaseController, {
        constructor: SearchWorkspaceDirectiveControllerFunc
    });

    return {
        scope:{
            searchResult: "=searchResult",
            searchPhrase: '@searchPhrase',
        },
        templateUrl : 'angular/app/modules/core/features/search/workspace/search_workspace_directive_template.html',
        controller : SearchWorkspaceDirectiveController,
        controllerAs : 'searchWorkspaceVm',
        bindToController : true

    };
};
